<ng-container>
    <cmps-wait-status
        *ngIf="hasPendingData === true"
        class="p-2"
    ></cmps-wait-status>
    <div
        class="text-center p-3"
        *ngIf="failLoad"
    >
        {{ failLoad }}
    </div>
    <table
        *ngIf="hasPendingData === false && data"
        class="goals-tab-sec"
    >
        <thead>
            <tr>
                <th
                    (click)="sortByField(0)"
                    class="limit-width"
                >
                    <div>{{ i18n._713_METRIC | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[0].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th (click)="sortByField(1)">
                    <div>{{ i18n._721_GOAL | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[1].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th (click)="sortByField(2)">
                    <div>{{ i18n._7367___TO_GOAL | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[2].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th (click)="sortByField(3)">
                    <div>{{ i18n._7325___IMPROVEMENT__INIT_ | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[3].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th (click)="sortByField(4)">
                    <div>{{ i18n._7326_ACTUAL__INIT_ | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[4].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th (click)="sortByField(5)">
                    <div>{{ i18n._7327_TARGET__INIT_ | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[5].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th (click)="sortByField(6)">
                    <div>{{ i18n._7387_EST__COMPLETION | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[6].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th (click)="sortByField(7)">
                    <div>{{ i18n._7308_COACH | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[7].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th (click)="sortByField(8)">
                    <div>{{ i18n._7329_CREATED_ON | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[8].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th (click)="sortByField(9)">
                    <div>{{ i18n._7330_CREATED_BY | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[9].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th (click)="sortByField(10)">
                    <div>{{ i18n._127_STATUS | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[10].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th (click)="sortByField(11)">
                    <div>{{ i18n._7332_DISPOSITION | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[11].direction | sortArrow"
                    ></cmps-icon>
                </th>

                <th
                    *ngIf="!displayCommitments"
                    (click)="sortByField(12)"
                >
                    <div>{{ i18n._7333___OF_COMMITMENTS | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[12].direction | sortArrow"
                    ></cmps-icon>
                </th>

                <ng-container *ngIf="displayCommitments">
                    <th class="goals-history-metricname">
                        {{ i18n._7334_BEHAVIOUR | translate }}
                        <div
                            class="cmps-cdk-cursor-pointer legacy:cmps-cdk-bg-color-green-100 cmps-cdk-border-radius-3px cmps-cdk-p-0dot25"
                            [title]="i18n._7335_HIDE_COMMITMENTS | translate"
                            tabindex="-1"
                            role="button"
                            (click)="hideSubs()"
                        >
                            <cmps-icon
                                class="cmps-cdk-fill-white"
                                svgIcon="arrow-collapse"
                            ></cmps-icon>
                        </div>
                    </th>
                    <th>
                        <div>{{ i18n._7336_SUB_BEHAVIOUR | translate }}</div>
                    </th>
                    <th>
                        <div>
                            {{ i18n._7337_COMMITMENT_STATUS | translate }}
                        </div>
                    </th>
                </ng-container>
            </tr>
        </thead>
        <tbody>
            <ng-container
                *ngFor="let o of displayData | slice: 0 : displayRecords"
            >
                <tr [hidden]="!o.display">
                    <td [rowSpan]="o.rowSpan">{{ o.metricName }}</td>
                    <td [rowSpan]="o.rowSpan">
                        {{ o.goalValue | number: '1.2-2' }}
                    </td>
                    <td [rowSpan]="o.rowSpan">
                        {{ o.pctGoal | number: '1.2-2'
                        }}<i *ngIf="o.pctGoal != null">%</i>
                    </td>
                    <td [rowSpan]="o.rowSpan">
                        {{ o.improvement | number: '1.2-2' }}
                    </td>
                    <td [rowSpan]="o.rowSpan">
                        {{ o.startActual | number: '1.2-2' }}
                    </td>
                    <td [rowSpan]="o.rowSpan">
                        {{ o.startTarget | number: '1.2-2' }}
                    </td>
                    <td [rowSpan]="o.rowSpan">
                        {{ o.completionDate | date: 'MM/dd/y' }}
                    </td>
                    <td [rowSpan]="o.rowSpan">{{ o.coachName }}</td>
                    <td [rowSpan]="o.rowSpan">
                        {{ o.createdOn | date: 'MM/dd/y' }}
                    </td>
                    <td [rowSpan]="o.rowSpan">{{ o.createdBy }}</td>
                    <td [rowSpan]="o.rowSpan">{{ o.statusName }}</td>
                    <td [rowSpan]="o.rowSpan">{{ o.disposition }}</td>
                    <td *ngIf="!displayCommitments">
                        <a
                            (click)="showSubs()"
                            title="{{
                                i18n._7338_SHOW_COMMITMENTS | translate
                            }}"
                            >{{ o.commitmentCount }}</a
                        >
                    </td>
                    <ng-container *ngIf="displayCommitments">
                        <ng-container *ngIf="o.goalmetrics; else noCommitments">
                            <td>{{ o.goalmetrics[0].behaviour }}</td>
                            <td>{{ o.goalmetrics[0].subBehaviour }}</td>
                            <td>{{ o.goalmetrics[0].statusName }}</td>
                        </ng-container>
                    </ng-container>
                    <ng-template #noCommitments>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                    </ng-template>
                </tr>
                <ng-container *ngIf="displayCommitments">
                    <tr *ngFor="let e of o.goalmetrics | slice: 1">
                        <td>{{ e.behaviour }}</td>
                        <td>{{ e.subBehaviour }}</td>
                        <td>{{ e.statusName }}</td>
                    </tr>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="allRecordsHidden || !data || !data.length">
                <tr>
                    <td [colSpan]="displayGoals ? 14 : 16">
                        {{ i18n._7323_NO_RESULTS_ | translate }}
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</ng-container>
